import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/manage/Delivered';
const options = { sort: sortOptions.dispatchedDate };

export const useDeliveredFilterStore = defineStore('deliveredFilterStore', {
  state: () => createBaseFilterState(options),
  actions: createFilterActions(filterAPI, options),
  getters: createFilterGetters(),
});
